import React from 'react';
import Selecto from 'react-selecto';
import PropTypes from 'prop-types';

const DragSelectComponent = ({
  dragContainer,
  selectableTargets,
  hitDetectionPercentile = 10,
  selectByClick = true,
  selectFromInside = true,
  continueSelect = false,
  continueSelectKey,
  onSelectCallback,
  onSelectionComplete
}) => {
  return (
    <Selecto
      dragContainer={dragContainer}
      selectableTargets={selectableTargets}
      hitRate={hitDetectionPercentile}
      selectByClick={selectByClick}
      selectFromInside={selectFromInside}
      continueSelect={continueSelect}
      toggleContinueSelect={[continueSelectKey]}
      onSelect={e => {
        e.added.forEach(el => {
          el.classList.add('selected');
        });
        e.removed.forEach(el => {
          el.classList.remove('selected');
        });
        if (onSelectCallback) {
          onSelectCallback(e);
        }
      }}
      onSelectEnd={e => onSelectionComplete &&
        onSelectionComplete(e)}
    />
  );
};

DragSelectComponent.propTypes = {
  dragContainer: PropTypes.string.isRequired,
  selectableTargets: PropTypes.arrayOf(PropTypes.string).isRequired,
  hitDetectionPercentile: (props, propName) => {
    // checks the rate at which the target overlaps the drag area to be selected
    if (props[propName] === undefined) {
      // will use default
      return;
    }
    const percentile = parseInt(props[propName]);
    if (isNaN(percentile) || (percentile < 0) || (percentile > 100)) {
      return new Error(
        'Prop "hitDetectionPercentile" expected to be a valid\
        integer between 0 and 100 inclusive.'
      );
    }
  },
  selectByClick: PropTypes.bool,
  selectFromInside: PropTypes.bool,
  continueSelect: PropTypes.bool,
  continueSelectKey: (props, propName) => {
    const continueKey = props[propName];
    if (!continueKey)
    {
      return;
    }

    if (typeof continueKey !== 'string') {
      return new Error('Prop continueSelectKey expects a string.');
    }
  },
  onSelectCallback: PropTypes.func,
  onSelectionComplete: PropTypes.func
};

export default DragSelectComponent;


// WEBPACK FOOTER //
// src/Components/DragSelectComponent.jsx